<template>
  <HeaderBase>
    <div
      class="flex items-center header-title cursor-pointer"
      @click="$router.back()">
      <span class="arrow arrow-l arrow-primary flex-shrink-0"></span>
      <span>
        <b>Заказчик: </b>
        <b class="text-muted">{{ $delve(customer, 'name') }}</b>
      </span>
    </div>
    <div class="flex flex-row items-center">

    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapGetters({
      customers: 'customers/customers',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    customer() {
      return this.customers(this.id);
    },
  },
};
</script>
